import { render } from "./TopThree.vue?vue&type=template&id=1073cb3e&scoped=true"
import script from "./TopThree.vue?vue&type=script&lang=js"
export * from "./TopThree.vue?vue&type=script&lang=js"

import "./TopThree.vue?vue&type=style&index=0&id=1073cb3e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kevin\\Desktop\\ArbeitFinderundBeraterVersionen\\TvBerater\\FernseherBeraterUpdate05012026\\form_try0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1073cb3e"]])

export default __exports__